import { SystemEvent, SystemEventLevel } from '@shared-ui/logger-context';

export const INFOSITE_CONTROLLER_INFO = new SystemEvent(SystemEventLevel.INFO, 'INFOSITE_CONTROLLER_INFO');
export const SEARCH_CONTROLLER_INFO = new SystemEvent(SystemEventLevel.INFO, 'SEARCH_CONTROLLER_INFO');
export const ROOM_AND_RATE_SUMMARY_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'ROOM_AND_RATE_SUMMARY_CONTROLLER_INFO'
);
export const CRUISE_PROMOTIONS_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'CRUISE_PROMOTIONS_CONTROLLER_INFO'
);
